<div *ngIf="prikaziStranicu" class="container-fluid">
  <h2 class="content-block">PARTNERI</h2>

  <div class="customTable partneri m-40">
    <dx-data-grid
      id="partneri"
      #tablicaPartneri
      [showColumnLines]="true"
      [dataSource]="partneri"
      noDataText="Nema partnera"
      [wordWrapEnabled]="true"
      keyExpr="id"
      [showBorders]="false"
      (onRowUpdated)="onRowUpdated($event)"
      (onToolbarPreparing)="onToolbarPreparing($event)"
    >
      <div *dxTemplate="let data of 'naslovTablice'">
        <div class="naslov">
          <h2 class="mb-0">Broj dana za utovar</h2>
          <p class="mt-0">Broj dana za utovar se oduzima od datuma narudžbe</p>
        </div>
      </div>

      <dxo-search-panel
        [visible]="true"
        [width]="240"
        placeholder="Pretraži..."
      >
      </dxo-search-panel>

      <dxo-paging [enabled]="true" [pageSize]="20"></dxo-paging>

      <dxo-pager
        [showPageSizeSelector]="true"
        [allowedPageSizes]="[10, 20, 30]"
        [showInfo]="true"
      >
      </dxo-pager>

      <dxo-editing
        mode="batch"
        [allowUpdating]="true"
        [selectTextOnEditStart]="selectTextOnEditStart"
        [startEditAction]="startEditAction"
      >
      </dxo-editing>

      <dxi-column
        dataField="sifra"
        caption="Šifra"
        alignment="left"
        [width]="150"
        [allowEditing]="false"
      ></dxi-column>
      <dxi-column
        dataField="naziv"
        caption="Naziv"
        [allowEditing]="false"
      ></dxi-column>
      <dxi-column dataField="otprema_mobitel" caption="Otprema mobitel" [allowEditing]="true" alignment="center" [width]="180">
        <dxo-lookup
          [dataSource]="prikazi"
          displayExpr="pr_naziv"
          valueExpr="idprikaz">
        </dxo-lookup>
      </dxi-column>
      <dxi-column dataField="grupaId" caption="Partner grupa" [width]="300">
        <dxo-lookup
          [dataSource]="grupe"
          displayExpr="pg_naziv"
          valueExpr="idpartnergrupa">
        </dxo-lookup>
      </dxi-column>
      <dxi-column dataField="prijevoznik" caption="Prijevoznik" [width]="130" alignment="center">
        <dxo-lookup
          [dataSource]="prijevoznikArray"
          displayExpr="pr_naziv"
          valueExpr="idprikaz">
        </dxo-lookup>
      </dxi-column>
      <dxi-column
        dataField="utovarDan"
        caption="Broj dana za utovar"
        alignment="center"
        [width]="200"
      ></dxi-column>
    </dx-data-grid>
  </div>
</div>
